import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  skipBeforeYouStartPage: undefined,
};

const plantDesignApplicationSlice = createSlice({
  name: 'plantDesignApplication',
  initialState,
  reducers: {
    storeSkipBeforeYouStartPage(state, action) {
      state.skipBeforeYouStartPage = action.payload;
    },
    clearSkipBeforeYouStartPage(state, action) {
      return initialState;
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(clearPlantDesignForm, () => {
  //     return initialState;
  //   });
  // },
});

export const { storeSkipBeforeYouStartPage, clearSkipBeforeYouStartPage } = plantDesignApplicationSlice.actions;
export const plantDesignApplicationReducer = plantDesignApplicationSlice.reducer;
